
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/turnaje/novy",
      function () {
        return require("private-next-pages/turnaje/novy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/turnaje/novy"])
      });
    }
  